import type { ScrollIntoViewIfNeededArgs } from "./types";

function isFullyVisible(
  container: HTMLElement,
  target: HTMLElement,
  offset = 0,
) {
  const c = container.getBoundingClientRect();
  const t = target.getBoundingClientRect();
  return (
    t.top >= c.top + offset &&
    t.bottom <= c.bottom - offset &&
    t.left >= c.left + offset &&
    t.right <= c.right - offset
  );
}

/**
 * Lightweight replacement for "scroll-to-element-if-needed".
 * - Only scrolls if target isn't fully visible inside container.
 * - Smooth by default.
 */
export function scrollIntoViewIfNeeded({
  container,
  target,
  options,
}: ScrollIntoViewIfNeededArgs) {
  const behavior = options?.behavior ?? "smooth";
  const block = options?.block ?? "nearest";
  const offset = options?.offset ?? 0;
  const raf = options?.raf ?? true;

  const run = () => {
    if (isFullyVisible(container, target, offset)) return;

    target.scrollIntoView({
      behavior,
      block,
      inline: "nearest",
    });
  };

  if (raf) {
    requestAnimationFrame(run);
  } else {
    run();
  }
}
